/**
 * playLiveSound — un son court PENDANT le live : la branche « en live » de l'ancien `PlaySound`
 * (`common/sound/PlaySound.js`), seule.
 *
 *  - Android se tait : `setAudioModeAsync` y remettrait l'audio en mode normal et couperait l'écho
 *    matériel de l'appel, et jouer sans lui prendrait le focus audio à l'appel ;
 *  - ailleurs, la session audio appartient à LiveKit : on n'y touche pas (pas de
 *    `setAudioModeAsync`), et le lecteur ne la rend pas en finissant (`keepAudioSessionActive`),
 *    sans quoi iOS couperait le son de l'appel dans les deux sens ;
 *  - le lecteur est rendu six secondes après.
 *
 * Les refus attendus (lecture automatique bloquée, source vide, lecture interrompue) ne sont pas des
 * erreurs ; les autres passent par la télémétrie.
 */
import { createAudioPlayer, type AudioSource } from "expo-audio"
import { Platform } from "react-native"

import { type EngineTelemetry } from "../../shared/telemetry"

const RELEASE_AFTER_MS = 6000
const EXPECTED = new Set(["NotAllowedError", "NotSupportedError", "AbortError"])

export function playLiveSound(source: AudioSource, telemetry: EngineTelemetry): void {
    if (Platform.OS === "android" || source == null) return
    try {
        const player = createAudioPlayer(source, { keepAudioSessionActive: true })
        player.play()
        setTimeout(() => {
            try {
                player.remove()
            } catch (error) {
                // Déjà rendu : il n'y a plus rien à rendre.
                void error
            }
        }, RELEASE_AFTER_MS)
    } catch (error) {
        if (error instanceof Error && EXPECTED.has(error.name)) return
        telemetry.error("play_sound", error)
    }
}
